export const ACTIONS_PREFIX = 'SpacesFavourite';
